import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import '../css/display-view.css';

const DEFAULT_PRESENTER_SLIDES = [
  { question: 'I am a Catholic', subtitle: 'Ask Me Questions' },
];
const DEFAULT_PRESENTER_INTERVAL = 8;

const DisplayView = () => {
  const [node, setNode] = useState(null);
  const [presenterSlides, setPresenterSlides] = useState(DEFAULT_PRESENTER_SLIDES);
  const [presenterInterval, setPresenterInterval] = useState(DEFAULT_PRESENTER_INTERVAL);
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    const channel = new BroadcastChannel('node-updates');
    channel.onmessage = (event) => {
      if (event.data.type === 'update') {
        setNode(event.data.node);
      }
    };

    return () => {
      channel.close();
    };
  }, []);

  useEffect(() => {
    const fetchPresenterSettings = async () => {
      try {
        const snap = await getDoc(doc(db, 'appSettings', 'presenterMode'));
        if (snap.exists()) {
          const data = snap.data();
          if (Array.isArray(data.slides) && data.slides.length > 0) {
            setPresenterSlides(data.slides);
          }
          if (data.intervalSeconds) {
            setPresenterInterval(data.intervalSeconds);
          }
        }
      } catch (err) {
        console.error('Failed to fetch presenter settings:', err);
      }
    };
    fetchPresenterSettings();
  }, []);

  const hasBody = node?.body && node.body.trim() !== '';

  useEffect(() => {
    if (hasBody || presenterSlides.length <= 1) return;

    const intervalId = setInterval(() => {
      setSlideIndex((prev) => (prev + 1) % presenterSlides.length);
    }, Math.max(2, presenterInterval) * 1000);

    return () => clearInterval(intervalId);
  }, [hasBody, presenterSlides, presenterInterval]);

  useEffect(() => {
    setSlideIndex(0);
  }, [hasBody]);

  const currentSlide = presenterSlides[slideIndex % presenterSlides.length] || DEFAULT_PRESENTER_SLIDES[0];

  return (
    <div className="display-view">
      {!hasBody ? (
        <div className="default-slide" key={slideIndex}>
          <h1 className="slide-question">{currentSlide.question}</h1>
          <p className="slide-subtitle">{currentSlide.subtitle}</p>
        </div>
      ) : (
        <div className="content-slide">
          <div
            className="slide-body"
            dangerouslySetInnerHTML={{ __html: node.body }}
          />
        </div>
      )}
      <div className="sole-mark">
        <img src="/sole-mark.png" alt="" className="sole-watermark" />
        <div className="sole-credit">soleministries.org</div>
      </div>
    </div>
  );
};

export default DisplayView;
